import { Box, Button, IconButton } from '@hover/blueprint';
import { iconChevronLeft } from '@hover/icons';
import React from 'react';
import { useHistory, useLocation } from 'react-router';

import { signupPaths } from 'src/shared/components/NavBar/StyledNavBar';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Route as Routes } from 'src/shared/route';

const hideBackButtonPaths = [
  '/onboarding/description',
  '/onboarding/welcome',
  '/onboarding/usage',
];

export const MobileOnboardingHeader = () => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const history = useHistory();
  const { pathname, search } = useLocation();
  const onBack = () => history.goBack();

  return (
    <Box
      alignItems="center"
      display={{ base: 'flex', tablet: 'none' }}
      flexDirection="row"
      justifyContent="space-between"
      w={1}
    >
      {!hideBackButtonPaths.includes(pathname) && (
        <IconButton
          icon={iconChevronLeft}
          label={t('back')}
          onClick={onBack}
          size="large"
          variant="ghost"
        />
      )}
      {signupPaths.includes(pathname) && (
        <Button
          as="a"
          fill="minimal"
          href={`${Routes.SIGN_UP_ONBOARDING.path}/welcome${search}`}
        >
          {t('onboarding.login')}
        </Button>
      )}
    </Box>
  );
};
